import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { ShadowlessElement } from '@blocksuite/std';
import { html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

import { dataViewI18nT } from '../../../core/i18n.js';
import { validationIconStyle } from '../../shared/empty-state/empty-state-css.js';

/**
 * Small warn-icon rendered inline next to invalid-range bars.
 * Supplies a tooltip describing the failure reason so users can act
 * without opening the row-detail dialog.
 */
export class GanttValidationIndicator extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor reason = dataViewI18nT('gantt.validation.startAfterEnd');

  override render(): TemplateResult {
    return html`<span class=${validationIconStyle} title=${this.reason}
      >!</span
    >`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'dv-gantt-validation-indicator': GanttValidationIndicator;
  }
}
